import ApiService from '@/common/api/api.service';

let apiBasePath = 'TurmaDisciplina';

const TurmaDisciplinaService = {

    async obterPorFiltro(filtro, paginacao, campoOrdenado, ordem) {
        let { data } = await ApiService.get(`${apiBasePath}/listar-disciplinas-por-filtro`, {
          params: {
            AnoLetivoId: filtro.anoLetivoId,
            SegmentacaoId: filtro.segmentacaoId,
            CursoId: filtro.cursoId,
            TurmaId: filtro.turmaId,
            DisciplinaId: filtro.disciplinaId,
            NumeroDaPagina: paginacao.numeroDaPagina,
            TamanhoDaPagina: paginacao.tamanhoDaPagina,
            CampoOrdenado: campoOrdenado,
            OrdenacaoAscendente: ordem
          },
        });
        return data;
      }
}

export default TurmaDisciplinaService;
